module.exports = __webpack_public_path__ + "static/media/herohomepage.aee288fd.png";